<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      ref="table"
      :category-filter-func="filterItem"
      :category-list="tabList"
      :icon="'mdi-heart'"
      :model="AttributeGroup"
      entity-name="attribute"
    >
      <template #item.attrubuteCount="{item}">
        <v-btn
          :height="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
          :icon="!$vuetify.breakpoint.lgAndUp"
          :style="!$vuetify.breakpoint.lgAndUp ? 'border-radius: 12px; background: #f57c00;' : ''"
          :width="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
          color="amber lighten-4 black--text"
          elevation="0"
          small
          @click.stop="showAttributeFor(item)"
        >
          <template v-if="!$vuetify.breakpoint.lgAndUp">
            <v-icon color="white">
              mdi-cog
            </v-icon>
          </template>
          <template v-if="$vuetify.breakpoint.lgAndUp">
            <div
              :class="!$vuetify.breakpoint.lgAndUp ? 'text-truncate' : ''"
              :style="!$vuetify.breakpoint.lgAndUp ? 'max-width: 100px;' : ''"
            >
              {{ $t('editAttribute') }}
            </div>
          </template>
        </v-btn>
      </template>
      <template #right>
        <template>
          <v-dialog
            v-model="showUploadDishDialog"
            :max-width="$vuetify.breakpoint.smAndUp? '60%' : ''"
            persistent
          >
            <template #activator="{on, attrs}">
              <v-btn
                :icon="!$vuetify.breakpoint.mdAndUp"
                class="ml-2"
                elevation="0"
                outlined
                v-bind="attrs"
                v-on="on"
              >
                <v-icon
                  :center="!$vuetify.breakpoint.mdAndUp"
                  :color="!$vuetify.breakpoint.mdAndUp ? 'white' : 'black'"
                  :left="$vuetify.breakpoint.mdAndUp"
                >
                  mdi-import
                </v-icon>
                <template v-if="$vuetify.breakpoint.mdAndUp">
                  <div
                    :style="$vuetify.breakpoint.mdAndDown ? 'max-width: 80px !important;' : '' && !$vuetify.breakpoint.lgAndUp ? 'max-width: 90px;' : ''"
                    class="text-truncate"
                  >
                    {{ $t('bulkImport') }}
                  </div>
                </template>
              </v-btn>
            </template>
            <v-card>
              <upload-page
                :file-type="'attribute'"
                :title="$t('AttributeInfo')"
                @close="closeDialog"
                @successImport="closeDialog"
              />
            </v-card>
          </v-dialog>
        </template>
        <v-dialog
          v-model="helpDialog"
          max-width="400px"
        >
          <v-card>
            <v-card-title>{{ $t('useInfo') }}</v-card-title>
            <v-card-text
              style="position: relative; height: 400px;overflow-y: scroll;"
            >
              <div class="text-h4">
                {{ $t('welcomeAG') }}
              </div>
              <div class="text-body-1 mt-4">
                <p v-html="$t('agHint1')" />
                <p>
                  {{ $t('agHint2') }}
                </p>
                <p>
                  {{ $t('agHint3') }}
                </p>
              </div>
            </v-card-text>
            <div
              :class="$vuetify.breakpoint.mdAndDown ? 'absoluteBtn' : ''"
              class="text-center pa-2"
            >
              <v-btn
                class="amber lighten-4 black--text"
                elevation="0"
                @click="read"
              >
                {{ $t('iUnderStand') }}
              </v-btn>
            </div>
          </v-card>
          <template />
        </v-dialog>
        <v-btn
          :small="$vuetify.breakpoint.mobile"
          elevation="0"
          outlined
          @click="startEditSort()"
        >
          <v-icon
            color="black"
            left
          >
            mdi-file-edit
          </v-icon>
          {{ $t('editShowSort') }}
        </v-btn>
        <v-btn
          :small="$vuetify.breakpoint.mobile"
          outlined
          @click="helpDialog=true"
        >
          <v-icon
            left
          >
            mdi-information-outline
          </v-icon>
          {{ $t('help') }}
        </v-btn>
      </template>
      <template #footer>
        <!-- Display information about attribute groups here if needed -->
      </template>
    </ik-data-table>
    <nice-dialog
      v-model="showSortEdit"
    >
      <sort-fragment
        :initial-list="attributeGroupList"
        :item-text="'_langsname'"
        item-sort="attributeGroupSort"
        @close="showSortEdit=false"
        @save="updateSort"
      />
    </nice-dialog>
  </div>
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import AttributeGroup from '@/model/dataLayer/api/dish/AttributeGroup'
import Attribute from '@/model/dataLayer/api/dish/Attribute'
import SortFragment from '@/views/AadenPages/dishes/dish/category/SortFragment'
import { Remember } from '@/model/global/GlobalSettings'
import i18n from '@/i18n'
import UploadPage from '@/views/AadenPages/dishes/dish-display/UploadPage'
import IKUtils from 'innerken-js-utils'
import { showSuccessMessage } from '@/model/utils/utils'
import NiceDialog from '@/views/widget/uiComponent/NiceDialog.vue'

export default {
  components: {
    SortFragment,
    UploadPage,
    IkDataTable,
    NiceDialog
  },
  data: function () {
    return ({
      attributeGroupList: [],
      showSortEdit: false,
      showUploadDishDialog: false,
      selectedAIdList: [],
      helpDialog: null,
      attributeList: [],
      showGroupAttribute: [],
      AttributeGroup,
      Attribute,
      showAttributeDialog: false,
      filter: null,
      currentAttributeGroup: null,
      // TODO: Translate
      tabList: [
        {
          name: i18n.t('required'),
          id: 1
        }, {
          name: i18n.t('multiSelect'), // 加料
          id: 2
        }
      ]
    })
  },
  async mounted () {
    this.attributeGroupList = await AttributeGroup.getList()
    if (!Remember.readAgHint) {
      this.helpDialog = true
    }
  },
  methods: {
    async updateSort (newList) {
      IKUtils.showLoading()
      const reqs = newList.map(async (it, i) => {
        it.attributeGroupSort = i + 1
        it.sort = it.attributeGroupSort
        return await AttributeGroup.edit(it, false)
      })
      const res = await Promise.allSettled(reqs)
      console.log(res)
      this.showSortEdit = false
      await this.$refs.table.reload()
      showSuccessMessage()
    },
    startEditSort (list) {
      this.showSortEdit = true
    },
    closeDialog () {
      this.showUploadDishDialog = false
      this.$refs.table.reload()
    },
    read () {
      Remember.readAgHint = true
      this.helpDialog = false
    },
    filterItem (item, currentTab) {
      if (currentTab.id === 1) {
        return item.required === (currentTab.id === 1)
      } else {
        return item.multiSelect === (currentTab.id === 2)
      }
    },
    showAttributeFor (item) {
      this.$router.push('/dishes/attributeByGroup/' + item.id)
    }
  }
}
</script>
